export default __webpack_public_path__ + "static/media/ES.4ec6583a.svg";